interface FormSelectOptionProps {
  title: string;
  description?: string;
  formId: string;
}

export const FormSelectOption = ({ title, description, formId }: FormSelectOptionProps) => (
  <div className="flex flex-col gap-0.5 min-w-0">
    <span className="text-sm truncate">{title}</span>
    {description && <span className="text-xs text-muted-foreground line-clamp-2">{description}</span>}
    <span className="text-xs text-muted-foreground font-mono truncate">{formId}</span>
  </div>
);
